const escape = {
    '"': '&quot;',
    "'": '&apos;',
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
};
const unescape = {
    '&quot;': '"',
    '&apos;': "'",
    '&lt;': '<',
    '&gt;': '>',
    '&amp;': '&',
};
const ESCAPE_REGEX = new RegExp(Object.keys(escape).join('|'), 'g');
const UNESCAPE_REGEX = new RegExp(Object.keys(unescape).join('|'), 'g');
export const escapeXMLString = (str) => str.replace(ESCAPE_REGEX, (match) => escape[match]);
export const unescapeXMLString = (str) => str.replace(UNESCAPE_REGEX, (match) => unescape[match]);
export const extractFirstValueByTagName = (xml, tagName) => {
    const xmlParser = new DOMParser();
    const xmlDoc = xmlParser.parseFromString(xml, 'text/xml');
    const values = xmlDoc.getElementsByTagName(tagName);
    if (values.length === 0) {
        return null;
    }
    return values[0].textContent;
};
